import { supabaseApi } from "../store/supabaseApi";
import { supabase } from "../utils/API";

export const movieReportApi = supabaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMovieReports: builder.query<any, any>({
      queryFn: async ({
        startDate,
        endDate,
        start,
        end,
        statusFilter,
        violationFilter,
        deputySearch,
        theatreSearch,
        sortColumn,
        sortDirection,
        subRole,
      }) => {
        let query = supabase
          .from("review_watched_movie")
          .select(
            `
          id,
          created_at,
          status,
          has_violation,
          ticket_request:ticket_requests!inner (
            id,
            movie_title,
            cinema_name
          ),
          deputy:users!deputy_id!inner (
            name,
            last_name,
            profile_picture,
            sub_role,
            emp_id,
            emp_position,
            phone_number,
            email,
            deputy_control_number
          )
        `,
            { count: "exact" },
          )
          .gte("created_at", `${startDate} 00:00:00`)
          .lte("created_at", `${endDate} 23:59:59`)
          .eq("deputy.sub_role", subRole || "DEPUTY")
          .order(sortColumn || "created_at", { ascending: sortDirection === "asc" })
          .range(start, end);

        if (statusFilter !== "ALL") {
          query = query.eq("status", statusFilter);
        } else {
          query = query.in("status", [
            "PENDING",
            "ACKNOWLEDGED",
            "REJECTED",
            "DUPLICATE",
          ]);
        }

        if (violationFilter === "WITH") {
          query = query.eq("has_violation", true);
        } else if (violationFilter === "NONE") {
          query = query.eq("has_violation", false);
        }

        if (deputySearch) {
          query = query.or(
            `name.ilike.%${deputySearch}%,last_name.ilike.%${deputySearch}%`,
            { foreignTable: "deputy" },
          );
        }

        if (theatreSearch) {
          query = query.ilike(
            "ticket_request.cinema_name",
            `%${theatreSearch}%`,
          );
        }

        const { data, count, error } = await query;

        if (error) throw error;

        return {
          data: {
            list: data ?? [],
            count: count ?? 0,
          },
        };
      },
      providesTags: ["deputy_reviews"],
    }),
  }),
});

export const { useGetMovieReportsQuery, useLazyGetMovieReportsQuery } = movieReportApi;
